import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'
import { selectPersona, selectComplianceEnabled, selectAuthLoading } from 'features/auth/ducks/selectors'
import { updateUserRoutine } from 'features/auth/ducks/actions'

const OPTIONS = [
  { value: 'manager', label: 'Manager', desc: 'Oversee buildings, report upward and track how your team is doing.' },
  { value: 'team_member', label: 'Team Member', desc: 'Focus on the work assigned to you. What to do today and this week.' },
]

const PersonaPrompt = () => {
  const dispatch = useDispatch()
  const persona = useSelector(selectPersona)
  const complianceEnabled = useSelector(selectComplianceEnabled)
  const isLoading = useSelector(selectAuthLoading)
  const [choice, setChoice] = useState(complianceEnabled ? 'manager' : 'team_member')
  const [submitting, setSubmitting] = useState(false)

  useEffect(() => {
    if (submitting && !isLoading) setSubmitting(false)
  }, [submitting, isLoading])

  if (persona !== null && persona !== undefined) return null

  const confirm = () => {
    if (submitting) return
    setSubmitting(true)
    dispatch(updateUserRoutine({ persona: choice }))
  }

  return (
    <Backdrop>
      <Card>
        <Title>Which best describes you?</Title>
        <Sub>You can change this any time from the header.</Sub>
        <Options>
          {OPTIONS.map(o => (
            <Option
              key={o.value}
              type='button'
              disabled={submitting}
              $active={choice === o.value}
              onClick={() => setChoice(o.value)}
            >
              <OptLabel>{o.label}</OptLabel>
              <OptDesc>{o.desc}</OptDesc>
            </Option>
          ))}
        </Options>
        <Confirm type='button' onClick={confirm} disabled={submitting}>
          {submitting ? 'Saving…' : 'Continue'}
        </Confirm>
      </Card>
    </Backdrop>
  )
}

export default PersonaPrompt

const Backdrop = styled.div`position:fixed;inset:0;background:rgba(12,18,41,0.45);display:flex;align-items:center;justify-content:center;z-index:1500;padding:24px;`
const Card = styled.div`width:100%;max-width:460px;background:#fff;border:1px solid #ececec;border-radius:16px;padding:28px;`
const Title = styled.h2`margin:0 0 4px;font-size:22px;color:#0C1229;`
const Sub = styled.p`margin:0 0 18px;font-size:13px;color:#64748b;`
const Options = styled.div`display:flex;flex-direction:column;gap:10px;margin-bottom:18px;`
const Option = styled.button`
  text-align:left;font:inherit;padding:14px;border-radius:12px;cursor:pointer;
  border:1px solid ${({ $active }) => $active ? '#0C1229' : '#ececec'};
  background:${({ $active }) => $active ? '#f6fbfa' : '#fff'};
  &:disabled{cursor:default;}
`
const OptLabel = styled.div`font-size:14px;font-weight:800;color:#0C1229;`
const OptDesc = styled.div`font-size:12.5px;color:#64748b;margin-top:2px;`
const Confirm = styled.button`
  font:inherit;padding:9px 18px;border:none;border-radius:999px;background:#0C1229;color:#fff;font-weight:800;cursor:pointer;
  &:disabled{opacity:0.6;cursor:default;}
`
